import { supabase } from '../clients/supabaseClient';

export type Faq = {
    id: string;
    category: string;
    question: string;
    answer: string;
    keywords: string[];
    sort_order: number;
    is_popular: boolean;
    is_active: boolean;
    created_at: string;
};

export type CreateFaqPayload = {
    category: string;
    question: string;
    answer: string;
    keywords: string[];
    sort_order: number;
    is_popular: boolean;
    is_active: boolean;
};

export type UpdateFaqPayload = Partial<CreateFaqPayload>;

export async function fetchFaqsFromDb(): Promise<Faq[]> {
    const { data, error } = await supabase
        .from('faqs')
        .select('*')
        .order('category', { ascending: true })
        .order('sort_order', { ascending: true });

    if (error) throw error;
    return (data ?? []) as Faq[];
}

export async function createFaqInDb(payload: CreateFaqPayload): Promise<Faq> {
    const { data, error } = await supabase
        .from('faqs')
        .insert([payload])
        .select()
        .single();

    if (error) throw error;
    return data as Faq;
}

export async function updateFaqInDb(id: string, patch: UpdateFaqPayload): Promise<Faq> {
    const { data, error } = await supabase
        .from('faqs')
        .update(patch)
        .eq('id', id)
        .select()
        .single();

    if (error) throw error;
    return data as Faq;
}

export async function deleteFaqFromDb(id: string): Promise<void> {
    const { error } = await supabase
        .from('faqs')
        .delete()
        .eq('id', id);

    if (error) throw error;
}